import React, { useState } from "react";
import "../styles/AccountClosureRequest.css";

export default function AccountClosureRequest() {
  const [filters, setFilters] = useState({
    fromDate: "",
    toDate: "",
    accountNumber: "",
  });

  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const handleFetch = (e) => {
    e.preventDefault();
    console.log(filters); // Replace with API call
  };

  const requestData = [
    {
      sn: 1,
      accountNumber: "MUZSAV000100021",
      accountHolder: "vivek",
      requestDate: "21 April 2025",
      status: "requested",
    },
    {
      sn: 2,
      accountNumber: "H02SAV000100008",
      accountHolder: "RAJEEV",
      requestDate: "27 May 2025",
      status: "requested",
    },
  ];

  return (
    <div className="AccountClosureRequest">
      {/* FILTER SECTION */}
      <section className="AccountClosureRequest-filter-section">
        <h2>Fetch Account Closure Requests</h2>
        <form onSubmit={handleFetch} className="AccountClosureRequest-filter-form">
          <div className="AccountClosureRequest-form-group">
            <label>From Date</label>
            <input
              type="date"
              name="fromDate"
              value={filters.fromDate}
              onChange={handleChange}
            />
          </div>
          <div className="AccountClosureRequest-form-group">
            <label>To Date</label>
            <input
              type="date"
              name="toDate"
              value={filters.toDate}
              onChange={handleChange}
            />
          </div>
          <div className="AccountClosureRequest-form-group">
            <label>Account Number</label>
            <input
              type="text"
              name="accountNumber"
              placeholder="Enter account number"
              value={filters.accountNumber}
              onChange={handleChange}
            />
          </div>
          <button type="submit" className="AccountClosureRequest-fetch-button">
            Fetch Report
          </button>
        </form>
      </section>

      {/* REPORT SECTION */}
      <section className="AccountClosureRequest-report-section">
        <h2>Account Closure Report</h2>
        <div className="AccountClosureRequest-controls">
          <label>
            Search:
            <input type="text" placeholder="Search..." />
          </label>
          <label>
            Show
            <select>
              <option>10</option>
              <option>25</option>
              <option>50</option>
            </select>
            entries
          </label>
        </div>

        <div className="AccountClosureRequest-table-wrapper">
          <table className="AccountClosureRequest-table">
            <thead>
              <tr>
                <th>SN</th>
                <th>Account Number</th>
                <th>Account Holder</th>
                <th>Request Date</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {requestData.map((row, i) => (
                <tr key={i}>
                  <td>{row.sn}</td>
                  <td>{row.accountNumber}</td>
                  <td>{row.accountHolder}</td>
                  <td>{row.requestDate}</td>
                  <td>{row.status}</td>
                  <td>
                    <button className="AccountClosureRequest-approve-btn">
                      Approve Request
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          
        </div>
      </section>
    </div>
  );
}
